import { z } from "zod";

import { schemes } from "../schema-validation";
import { taskDefinitionInputSchema } from "../tasks/schemas/taskDefinitionSchema";
import { baseEventInput } from "./baseEvent";

export const companyTaskDefinitionEvent = baseEventInput.merge(
  z.object({
    source: z.literal("company.task-definitions"),
    companyId: schemes.uuid(),
    payload: z.array(
      taskDefinitionInputSchema.pick({
        taskDefinitionId: true,
        enabled: true,
        default: true,
      })
    ),
  })
);

export type CompanyTaskDefinitionEvent = z.infer<
  typeof companyTaskDefinitionEvent
>;
